(function () {
  function cartApi() {
    return window.LubanCartDrawer || null;
  }

  function isRtl() {
    return document.documentElement.getAttribute('dir') === 'rtl';
  }

  function updateArrowState(viewport, prevBtn, nextBtn) {
    if (!viewport || !prevBtn || !nextBtn) return;
    var maxScroll = viewport.scrollWidth - viewport.clientWidth;
    var tolerance = 2;
    if (isRtl()) {
      prevBtn.disabled = viewport.scrollLeft >= -tolerance;
      nextBtn.disabled = viewport.scrollLeft <= -(maxScroll - tolerance);
    } else {
      prevBtn.disabled = viewport.scrollLeft <= tolerance;
      nextBtn.disabled = viewport.scrollLeft >= maxScroll - tolerance;
    }
  }

  function initCarousel(root) {
    var viewport = root.querySelector('[data-luban-recs-viewport]');
    var prevBtn = root.querySelector('[data-luban-recs-prev]');
    var nextBtn = root.querySelector('[data-luban-recs-next]');
    if (!viewport) return;

    var scrollAmount = function () {
      var card = root.querySelector('.luban-recs__card');
      return card ? card.offsetWidth + 12 : viewport.clientWidth * 0.85;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var dir = isRtl() ? 1 : -1;
        viewport.scrollBy({ left: dir * scrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var dir = isRtl() ? -1 : 1;
        viewport.scrollBy({ left: dir * scrollAmount(), behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', function () {
      updateArrowState(viewport, prevBtn, nextBtn);
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateArrowState(viewport, prevBtn, nextBtn);
    });

    updateArrowState(viewport, prevBtn, nextBtn);
  }

  function initAutoScroll(root) {
    var viewport = root.querySelector('[data-luban-recs-viewport]');
    if (!viewport) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cards = root.querySelectorAll('.luban-recs__card');
    if (cards.length < 2) return;

    var paused = false;
    var intervalMs = 4500;

    var scrollStep = function () {
      var card = root.querySelector('.luban-recs__card');
      return card ? card.offsetWidth + 16 : viewport.clientWidth * 0.85;
    };

    var tick = function () {
      if (paused) return;

      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (maxScroll <= 2) return;

      if (isRtl()) {
        if (viewport.scrollLeft <= -(maxScroll - 2)) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          viewport.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
        }
      } else if (viewport.scrollLeft >= maxScroll - 2) {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        viewport.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      }
    };

    root.addEventListener('mouseenter', function () {
      paused = true;
    });

    root.addEventListener('mouseleave', function () {
      paused = false;
    });

    root.addEventListener('focusin', function () {
      paused = true;
    });

    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) {
        paused = false;
      }
    });

    viewport.addEventListener('pointerdown', function () {
      paused = true;
    });

    viewport.addEventListener('pointerup', function () {
      window.setTimeout(function () {
        if (!root.matches(':hover')) {
          paused = false;
        }
      }, 1200);
    });

    window.setInterval(tick, intervalMs);
  }

  function setButtonState(button, state) {
    var label = button.querySelector('.luban-recs__add-text');
    var spinner = button.querySelector('.luban-recs__add-spinner');
    if (state === 'loading') {
      button.disabled = true;
      if (label) label.hidden = true;
      if (spinner) spinner.hidden = false;
      return;
    }
    var isAr = document.documentElement.getAttribute('lang') === 'ar';
    var addedText = isAr ? 'تمت الإضافة' : 'Added';
    var addText = isAr ? '+ أضف' : '+ Add';

    if (state === 'added') {
      button.disabled = false;
      button.classList.add('is-added');
      if (label) {
        label.hidden = false;
        label.textContent = addedText;
      }
      if (spinner) spinner.hidden = true;
      window.setTimeout(function () {
        button.classList.remove('is-added');
        if (label) label.textContent = addText;
      }, 1800);
      return;
    }
    button.disabled = false;
    if (label) {
      label.hidden = false;
      label.textContent = addText;
    }
    if (spinner) spinner.hidden = true;
  }

  function quickAdd(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var api = cartApi();
    setButtonState(button, 'loading');

    var addPromise = api
      ? api.addAndOpen(Number(variantId))
      : Promise.reject(new Error('Cart drawer unavailable'));

    addPromise
      .then(function () {
        setButtonState(button, 'added');
      })
      .catch(function (error) {
        setButtonState(button, 'idle');
        window.alert(error.message || 'Could not add to cart');
      });
  }

  function initQuickAdd(root) {
    root.addEventListener('click', function (event) {
      var button = event.target.closest('.luban-recs__add-btn');
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      quickAdd(button);
    });
  }

  function initRoot(root) {
    if (root.dataset.lubanRecsReady === 'true') return;
    root.dataset.lubanRecsReady = 'true';
    initCarousel(root);
    initAutoScroll(root);
    initQuickAdd(root);
  }

  function initAll() {
    document.querySelectorAll('[data-luban-recs]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
